// Module
var code = "<span> ${NOTIFICATIONS.NO_LINKED_RECORDS} </span>";
// Exports
export default code;